// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"c368f356","513":"952f5c47"}[chunkId] + ".chunk.js";
};